import { useContext } from 'react'
import { UserSubscriptionContext } from '../context/UserSubscriptionProvider'
import { UserSubscriptionContextType } from '../services/interfaces/map'

const useUserSubscription = (): UserSubscriptionContextType => {
  return useContext(UserSubscriptionContext)
}

export default useUserSubscription